import {useQuery} from '@tanstack/react-query';
import {fetch} from '../services/ReportTypesService';

export const useReportType = (reportTypeId?: string) => {

    const reportTypeQuery = useQuery({
        queryKey: ['reportType', reportTypeId],
        queryFn: () => fetch(reportTypeId!),
        enabled: !!reportTypeId,
    });

    return {
        record: reportTypeQuery.data,
        loading: reportTypeQuery.isLoading,
        fetchRecord: reportTypeQuery.refetch,
    };
};
